module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-assignment"
  }, [(_vm.isTutorialChecked) ? _c('CatTutorial') : _vm._e(), _vm._v(" "), _c('NavigationBar'), _vm._v(" "), _c('div', {
    staticClass: "assignment-header"
  }, [_c('div', {
    staticClass: "cl-container title"
  }, [_vm._v(_vm._s(_vm.$t('common.class_assignment')))])]), _vm._v(" "), _c('div', {
    staticClass: "row assignment-container"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-12 col-xs-12 px-6"
  }, [_c('div', {
    staticClass: "cl-card row assignment-class-filter"
  }, [_c('b-dropdown', {
    attrs: {
      "text": _vm.selectedClassName,
      "variant": "variant"
    }
  }, _vm._l((_vm.filterClasses), function(item) {
    return _c('b-dropdown-item', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.selectClass(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 1)], 1), _vm._v(" "), (_vm.selectedClassId !== 0) ? _c('div', {
    staticClass: "row assignment-stats-score"
  }, [_c('div', {
    staticClass: "col-6 user-score"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('assignment.user_score')) + " "), _c('strong', [_vm._v("    " + _vm._s(_vm.userScore || 0) + _vm._s(_vm.$t('common.score_value')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 class-score"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('assignment.class_average_score')) + " "), _c('strong', [_vm._v("  " + _vm._s(_vm.classScore || 0) + _vm._s(_vm.$t('common.score_value')) + "\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cl-card assignment-stats-filter row"
  }, _vm._l((_vm.filterAssignmentStats), function(item) {
    return _c('div', {
      key: item.code,
      staticClass: "col-3 assignment-stats",
      class: {
        'active': _vm.selectedStats === item.code
      },
      on: {
        "click": function($event) {
          return _vm.selectStats(item.code)
        }
      }
    }, [_c('div', {
      staticClass: "assignment-count"
    }, [_vm._v(_vm._s(item.value || 0))]), _vm._v(" "), _c('div', {
      staticClass: "assignment-name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-12 col-xs-12 px-6"
  }, [(_vm.busy) ? [_c('div', {
    style: ({
      'padding': '24px'
    })
  }, [_c('LoadingBounce')], 1)] : [(_vm.isFilterAssignments) ? [_c('Assignment', {
    attrs: {
      "eventLabel": 'assignment',
      "assignments": _vm.filterAssignments,
      "isBlock": true
    }
  }), _vm._v(" "), (_vm.filterAssignments.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()] : [_c('div', {
    staticClass: "empty-assignment"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img_empty_assignment.png",
      "alt": "empty-assignment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.empty_assignment')))])])]]], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d93ef2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-assignment/views/CatAssignment.vue
// module id = 1589
// module chunks = 1